import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

import { IconSizes, IconUsageTypes, IrisIconModule } from '@sondermind/iris/icon';

@Component({
  selector: 'pill',
  standalone: true,
  imports: [CommonModule, IrisIconModule],
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
})
export class PillComponent {
  @Input() icon: string = 'verified_user';
  @Input() displayText: string = '';
  @HostBinding('attr.data-test') dataTestValue = 'pill';
  iconDecorativeUsage = IconUsageTypes.DECORATIVE;
  iconSmallSize = IconSizes.SM;
}
